import {Component, Renderer2, Inject, OnInit} from '@angular/core';
import {DOCUMENT, NgIf} from '@angular/common';

@Component({
  selector: 'app-accessibility-gov-co',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './accessibility-gov-co.component.html',
  styleUrl: './accessibility-gov-co.component.scss'
})
export class AccessibilityGovCoComponent implements OnInit {

  private fontSize: number = 14;
  private highContrastMode: boolean = false;
  private readonly MIN_FONT_SIZE = 11;
  private readonly MAX_FONT_SIZE = 17;
  private readonly DEFAULT_FONT_SIZE = 14;
  private readonly FONT_STEP = 1;
  hasModifyFont: boolean = false;
  constructor(private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit(): void {
    this.loadSavedSettings();
  }


  aumentarFuente(): void {
    if (this.hasMaximumFontSize) return;
    this.fontSize += this.FONT_STEP;
    this.applyFontSize();
    this.saveSettings();
    this.modificarFuente();
  }


  disminuirFuente(): void {
    if (this.hasMimimusFontSize) return;
      this.fontSize -= this.FONT_STEP;
      this.applyFontSize();
      this.saveSettings();
    this.modificarFuente();
  }


  modificarFuente(){
    this.hasModifyFont = true;
  }

  cambiarContraste(): void {
    this.highContrastMode = !this.highContrastMode;

    if (this.highContrastMode) {
      this.renderer.addClass(this.document.body, 'high-contrast');
    } else {
      this.renderer.removeClass(this.document.body, 'high-contrast');
    }

    this.saveSettings();
  }

  private applyFontSize(): void {
    this.renderer.setStyle(
      this.document.documentElement,
      'font-size',
      `${this.fontSize}px`
    );
  }

  restablecerFuente() {
    this.fontSize = this.DEFAULT_FONT_SIZE;
    this.applyFontSize();
    this.saveSettings();
    this.hasModifyFont = false;
  }

  private saveSettings(): void {
    localStorage.setItem('appFontSize', this.fontSize.toString());
    localStorage.setItem('appHighContrast', this.highContrastMode.toString());
  }

  private loadSavedSettings(): void {
    const savedFontSize = localStorage.getItem('appFontSize');
    const savedContrast = localStorage.getItem('appHighContrast');

    if (savedFontSize) {
      this.fontSize = parseInt(savedFontSize, 10);
      this.hasModifyFont = this.fontSize !== this.DEFAULT_FONT_SIZE;
      this.applyFontSize();
    }

    if (savedContrast === 'true') {
      this.highContrastMode = true;
      this.renderer.addClass(this.document.body, 'high-contrast');
    }
  }

  get hasMimimusFontSize(): boolean {
    return this.fontSize <= this.MIN_FONT_SIZE;
  }

  get hasMaximumFontSize(): boolean {
    return this.fontSize >= this.MAX_FONT_SIZE;
  }
}
